<!-- 載入中 -->
<template>
    <div class="loading-mask bg-red" v-show="show">
        <div class="circle-loading-container">
            <div class="circle-loading"></div>
            <p>LOADING...</p>
        </div>
    </div>
</template>

<script type="text/javascript">
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
            required: true,
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="sass" scoped>
@import '@/sass/_variable'

.loading-mask
    background-color: rgba($white, .4)
    width: 100vw
    height: 100vh
    top: 0
    left: 0
    position: fixed
    z-index: 99999

@keyframes circleRun
    0%
        transform: rotate(0)
    50%
        transform: rotate(180deg)
    100%
        transform: rotate(360deg)

.circle-loading-container
    position: absolute
    text-align: center
    top: calc(50% - 6em)
    left: calc(50% - 3em)
    z-index: 2
    // &:after
    //     background: url('../assets/nav_logo.png') no-repeat 50% / contain
    //     content: ''
    //     display: inline-block
    //     position: absolute
    //     top: 1.8em
    //     left: .8em
    //     width: 4.5em
    //     height: 2em
    .circle-loading
        $s: 3em
        // background-color: rgba($green, .4)
        border: 5px solid $deepGreen
        border-right-color: transparent
        border-bottom-color: transparent
        border-radius: 50%
        display: inline-block
        width: $s
        height: $s
        margin-bottom: .8em
        animation-name: circleRun
        animation-duration: 600ms
        animation-iteration-count: infinite
        animation-timing-function: ease-in
        animation-delay: -100ms
    p
        color: $deepGreen
        font-size: .8em
        line-height: 1.2
        margin-top: -.8em
</style>
